import {Component} from '@angular/core';
import {Block}     from "../../block";

@Component({
    selector   : 'app-category-list',
    templateUrl: './category-list.component.html',
})
export class CategoryListComponent extends Block {

}
